import { useEffect, useState } from "react"
import Calendar from "react-calendar"
import moment from "moment"
import 'moment/locale/ru'

import { IconClearClose } from "@img/icons"
import { Flex, Modal, Button } from "@ui/index"

moment.locale('ru')


/** Интерфейс окна - Выбор даты из календаря */
export interface IModalCalendar {
    isOpen: boolean
    currentDate?: string

    handleButtonOk?: (stringDate: string) => void
    handleButtonCancel?: () => void
}


/** Окно - Выбор даты из календаря */
export const ModalCalendar = ({ isOpen, currentDate, handleButtonOk, handleButtonCancel }: IModalCalendar) => {
    type ValuePiece = Date | null
    type Value = ValuePiece | [ValuePiece, ValuePiece]

    const [selectedDate, setSelectedDate] = useState<Value>(new Date())

    useEffect(() => {
        if (isOpen) {
            let defaultDate: Date = new Date()

            if (currentDate) {
                const [day, month, year] = currentDate.split(".")
                defaultDate = new Date(
                    Number(year),
                    Number(month) - 1,
                    Number(day)
                )
            }

            setSelectedDate(defaultDate)
        }

        return () => {
            setSelectedDate(new Date())
        }
    }, [isOpen, currentDate])

    const handleChange = (value: Value) => {
        const date = Array.isArray(value) ? value[0] : value
        if (!date) return

        setSelectedDate(value)
        handleButtonOk?.(moment(date).format("DD.MM.YYYY"))
    }

    return (
        <Modal isOpen={isOpen} overflowY="hidden" isEsc isWrapper onCancel={handleButtonCancel}>
            <Flex className="modal_container">
                <Flex flexDirection="row" alignItems="center" justifyContent="space-between" className="modal_container-header">
                    <h4>Выбор даты...</h4>

                    <Button variant="icon" size="md" onClick={handleButtonCancel}>
                        <IconClearClose />
                    </Button>
                </Flex>

                <Flex gap="4px" className="modal_container-body">
                    <Flex className="modal_container-content">
                        <Calendar
                            locale="ru-RU"
                            value={selectedDate}
                            onChange={handleChange}
                            selectRange={false}

                            formatShortWeekday={(locale, date) => moment(date).format('dd')}
                            formatMonthYear={(locale, date) => moment(date).format('MMMM YYYY')}
                        />
                    </Flex>
                </Flex>
            </Flex>
        </Modal>
    )
}
